import axiosRepdPublic from "Axios";

export const fetchStateMunicipalityWithCedula = () => 
    axiosRepdPublic.get(`version_publica/repd-version-publica-get-estados-with-cedulas/`)

export const fetchEstatusWithCedula = () => 
    axiosRepdPublic.get(`version_publica/repd-version-publica-get-estatus-cedulas/`)

export const identityCardsOfMissingPersons = (params) => {
    const queryParams = new URLSearchParams(
        Object.entries(params).filter(([_, value]) => value != null && value !== "")
    );
  
    return axiosRepdPublic.get(`/version_publica/repd-version-publica-cedulas-busqueda/?${queryParams}&limit=12`)
};